import { useCallback, useState } from 'react'

import { Box, Grid, IconButton, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import AddCircleIcon from '@material-ui/icons/AddCircle'

import ProjectCreator from './ProjectCreator'
import ProjectList from './ProjectsList'

const useStyles = makeStyles(() => ({
  title: {
    marginBottom: '0.5rem',
  },
}))
const ProjectManager: React.FC = () => {
  const classes = useStyles()
  const [creatingProject, setCreatingProject] = useState(false)
  const toggleCreatingProject = useCallback(() => {
    setCreatingProject((prev) => !prev)
  }, [setCreatingProject])
  return (
    <Box>
      <Grid container alignItems='center' spacing={2} className={classes.title}>
        <Grid item>
          <Typography variant='h5'>Projects</Typography>
        </Grid>
        <Grid item>
          <IconButton
            size='small'
            disabled={creatingProject}
            onClick={toggleCreatingProject}
            color='primary'
          >
            <AddCircleIcon />
          </IconButton>
        </Grid>
      </Grid>
      <ProjectList />
      {creatingProject && <ProjectCreator toggleCreatingProject={toggleCreatingProject} />}
    </Box>
  )
}
export default ProjectManager
